var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.192 28C8.928 28 8.688 27.88 8.52 27.688C7.656 26.704 0 17.992 0 13.192C0 8.128 4.128 4 9.192 4C14.256 4 18.384 8.128 18.384 13.192C18.384 17.968 10.728 26.704 9.864 27.688C9.696 27.88 9.456 28 9.192 28ZM9.192 5.824C5.136 5.824 1.824 9.136 1.824 13.192C1.824 16.36 6.648 22.672 9.192 25.696C11.736 22.696 16.56 16.36 16.56 13.192C16.56 9.136 13.248 5.824 9.192 5.824Z",
    fill: "#0D6EFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19199 17.9199C6.64798 17.9199 4.58398 15.8559 4.58398 13.3119C4.58398 10.7679 6.64798 8.70386 9.19199 8.70386C11.736 8.70386 13.8 10.7679 13.8 13.3119C13.8 15.8559 11.736 17.9199 9.19199 17.9199ZM9.19199 10.5279C7.65599 10.5279 6.40799 11.7759 6.40799 13.3119C6.40799 14.8479 7.65599 16.0959 9.19199 16.0959C10.728 16.0959 11.976 14.8479 11.976 13.3119C11.976 11.7759 10.728 10.5279 9.19199 10.5279Z",
    fill: "#0D6EFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.49dd6988deadea677013b31d93011e29.svg";
export { ForwardRef as ReactComponent };